/* eslint-disable import/no-cycle */
import { DataService } from '../../../config/dataService/dataService';
import { getQueryString } from '../../../utility/utility';

export const submitMerchantRegistrationApi = (data) => DataService.post('/merchant/registration', data);

export const validateMerchantRegistrationLinkApi = (data) =>
  DataService.get(`/merchant/registration/validate-link?${getQueryString(data)}`);

export const submitAdministrativeBillingDetailsApi = (data) =>
  DataService.put('/merchant/administrative-billing-details', data);

export const getAdministrativeBillingDetailsApi = () => DataService.get('/merchant/administrative-billing-details');

export const sendContractOtpApi = () => DataService.post('/merchant/send-contract-otp', {});

export const verifyContractOtpApi = (data) => DataService.post('/merchant/verify-contract-otp', data);

export const getContractApi = (lang) => {
  const url = lang ? `/merchant/contract?lang=${lang}` : '/merchant/contract';
  return DataService.get(url, { responseType: 'blob' });
};

export const getMerchantPaymentRequiredInfoApi = () =>
  DataService.get('merchant/payment-required-info');

export const verifyMerchantCheckoutSessionApi = (sessionId) =>
  DataService.get(`/merchant/verify-checkout-session?${getQueryString({ session_id: sessionId })}`);
